module.exports = __webpack_public_path__ + "static/media/goal.43bf3941.png";